// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"69b60f6f","128":"52a5fb01","156":"c4017437","213":"08462194","282":"c5d83f4d","434":"d04860fe","453":"4d6ed93c","484":"0a188285","485":"4840f40b","512":"873b84d5","557":"ea8a2cf1","594":"482cab1b","709":"cf8923f1","723":"e995ab9e","837":"3653f141","947":"925ecfdd"}[chunkId] + ".chunk.js";
};